import type { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { fonts, menuItemStyles } from '../../styles';

export const styles = (theme: Theme) => ({
    paper: {
        borderRadius: 0,
        boxShadow: 'none',
        border: `1px solid ${theme.palette.grey[500]}`,
        overflowX: 'visible' as const,
    },
    menuList: {
        paddingTop: 0,
    },
    menuItem: {
        ...menuItemStyles(theme),
    },
    menuLabel: {
        fontSize: '13px',
        letterSpacing: '0.1px',
        fontWeight: fonts.weights.regular,
        color: theme.palette.grey[800],
        paddingLeft: theme.spacing(3),
    },
    divider: {
        color: theme.palette.grey[300],
    },
    menuGroupWrapper: {
        display: 'block',
        outline: 'none',
    },
    popper: {
        display: 'none',
    },
    collapsibleOptionGroupArrow: {
        width: '25px',
        marginRight: '10px',
        height: '100%',
        verticalAlign: 'middle',
    },
});

export const useStyles = makeStyles()(styles);
